// Style « capsule » des sélecteurs de la barre de la liste (maquette Barre d'outils) :
// violet des maquettes (#6F3FA8 = primary.dark) pour l'option active.
export const pillToggleGroupClassName =
    "gap-0 rounded-full border border-surface-secondary bg-surface-neutral p-0.5";

export const pillToggleItemClassName =
    "h-8 whitespace-nowrap rounded-full px-3 text-text-body hover:text-text-body data-[state=on]:bg-primary-dark data-[state=on]:text-text-invert hover:bg-surface-primaryHover data-[state=on]:hover:bg-primary-darker";

export const pillToggleLabelClassName =
    "whitespace-nowrap text-sm font-semibold text-text-label";

export const pillToggleCompactItemClassName =
    "gap-1 px-2 text-sm [&_svg]:size-3.5";
